import Box from '@mui/material/Box';
import { useWatch } from 'react-hook-form';

import { StyledTypography } from 'reservations/base/components/StyledTypography';
import { FormHeader } from 'reservations/form/components/FormHeader';
import { getFormattedPositionInLine } from 'reservations/waitlist/helpers/getFormattedPositionInLine';
import { useWaitlist } from 'reservations/waitlist/providers/WaitlistProvider';

const JoinTheWaitlistFormHeader = () => {
  const { waitCount } = useWaitlist();
  const partySize = useWatch({
    name: 'partySize'
  });

  return (
    <Box>
      <FormHeader />
      <StyledTypography sx={{ mt: '8px' }}>{partySize} guests</StyledTypography>
      <StyledTypography>
        You&apos;ll be <strong>{getFormattedPositionInLine(waitCount)}</strong>{' '}
        in line.
      </StyledTypography>
    </Box>
  );
};

export default JoinTheWaitlistFormHeader;
